jQuery(function($)
{
    /**
	 * @type {object jQuery}
	 */
    var $quantityEquationTriggers = $('.js-quantity-equation-trigger');

    /**
	 * @type {object jQuery}
	 */
    var $quantityEquationInputs = $('.js-quantity-equation-input');

    /**
	 * Get highest quantity input value
	 * @param  {object jQuery} $quantityInput Quantity input elements
	 * @return {number} Value of quantity input
	 */
    function fetchHighestQuantity(quantityEquationGroup)
    {
        var $quantityInputs = $quantityEquationInputs.filter(function()
        {
            return $(this).data('quantityEquationGroup') == quantityEquationGroup;
        });

        console.log(quantityEquationGroup, $quantityInputs);

        var max = 0;

        for (var i = 0; i < $quantityInputs.length; ++i)
        {
            max = Math.max(max, parseInt($quantityInputs.eq(i).val()));
        }

        return max;
    }

    /**
	 * Set highest input value for all inputs
	 * @param {object jQuery} $quantityInput Quantity input elements
	 * @param {number} value Value for inputs
	 */
    function setValueForInputs(quantityEquationGroup, value)
    {
        var $quantityInputs = $quantityEquationInputs.filter(function()
        {
            return $(this).data('quantityEquationGroup') == quantityEquationGroup;
        });

        if (isNaN(value))
        {
            value = 0;
        }

        $quantityInputs.each(function()
        {
            $(this).val(value);
            handleTriggerProductQuantity($(this));
        });
    }

    /**
	 * checks or unchecks checkboxes for product
	 */
    function handleTriggerProductQuantity(e)
    {
        var $checkbox = $('.choise input', $(e).closest('.js-product-list-item'));

        if ($(e).val() > 0 && !$checkbox.prop('checked'))
        {
            $checkbox.click();
        }
        else if ($(e).val() <= 0 && $checkbox.prop('checked'))
        {
            $checkbox.click();
        }
    }

    /**
	 * Activate quantity equation and set highest input value for all inputs after button click
	 * @param {event} e
	 */
    function handleClick(e)
    {
        e.preventDefault();

        var $quantityEquationTrigger = $(this);

        var quantityEquationGroup = $quantityEquationTrigger.data('quantityEquationGroup');

        if ($quantityEquationTrigger.hasClass('js-quantity-equation-active'))
        {
            $quantityEquationTrigger.removeClass('js-quantity-equation-active');
            $quantityEquationTrigger.find('i').removeClass('fa-chain')
                .addClass('fa-link-slash');
        }
        else
        {
            $quantityEquationTrigger.addClass('js-quantity-equation-active');
            $quantityEquationTrigger.find('i').removeClass('fa-link-slash')
                .addClass('fa-chain');
        }

        var highestQuantity = fetchHighestQuantity(quantityEquationGroup);

        setValueForInputs(quantityEquationGroup, highestQuantity);
    }

    /**
	 * Set quantity value for all inputs if equation is active
	 */
    function handleChange()
    {
        var $quantityEquationInput = $(this);

        var quantityEquationGroup = $quantityEquationInput.data('quantityEquationGroup');

        var $quantityEquationTrigger = $quantityEquationTriggers.filter(function()
        {
            return $(this).data('quantityEquationGroup') == quantityEquationGroup;
        });

        var inputValue = $quantityEquationInput.val();

        if ($quantityEquationTrigger.hasClass('js-quantity-equation-active'))
        {
            setValueForInputs(quantityEquationGroup, inputValue);
        }
    }

    /**
	 * Initialize events
	 */
    function initEvents()
    {
        $quantityEquationTriggers.on('click', handleClick);
        $quantityEquationInputs.on('change keyup focus input', handleChange);
    }

    /**
	 * Initialize quantity equation
	 */
    function init()
    {
        initEvents();
    }

    init();
});
